"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.176.2
//   protoc               v4.23.4
// source: bens-proto/proto/bens.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = exports.TokenType = exports.protobufPackage = void 0;
/* eslint-disable */
exports.protobufPackage = "blockscout.bens.v1";
var TokenType;
(function (TokenType) {
    TokenType["NATIVE_DOMAIN_TOKEN"] = "NATIVE_DOMAIN_TOKEN";
    TokenType["WRAPPED_DOMAIN_TOKEN"] = "WRAPPED_DOMAIN_TOKEN";
    TokenType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TokenType || (exports.TokenType = TokenType = {}));
var Order;
(function (Order) {
    Order["ORDER_UNSPECIFIED"] = "ORDER_UNSPECIFIED";
    Order["ASC"] = "ASC";
    Order["DESC"] = "DESC";
    Order["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Order || (exports.Order = Order = {}));
